<div class="modal-header">
	<h4 class="modal-title">{{title}}</h4>
</div>
<div class="modal-body">
	<p>{{{hint}}}</p>
	{{#each checkboxMap}}
		<div class="checkbox checkbox-primary">
			<input id="js-{{@key}}" class="js-checkbox" type="checkbox" name="{{@key}}" {{#if checked}}checked="checked"{{/if}}>
			<label for="js-{{@key}}">{{label}}</label>
		</div>
	{{/each}}
</div>
<div class="modal-footer">
	{{#if action_label}}
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">
		{{#if cancel_label}}{{cancel_label}}{{else}}{{TR "Abbrechen"}}{{/if}}
	</button>
	<a class="btn btn-primary ct-confirm-dialog" id="js-action">{{action_label}}</a>
	{{else}}
	<button id="ct-ok" type="button" class="btn btn-white" data-dismiss="modal">
		{{TR "OK"}}
	</button>
	{{/if}}
</div>
